import _defineProperty from "/home/victordibia/projects/projectlida/lidaweb/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { resetComponent, resetIcon } from '../../style';
import { genCollapseMotion } from '../../style/motion';
import { genComponentStyleHook, mergeToken } from '../../theme/internal';
export var genBaseStyle = function genBaseStyle(token) {
  var _$concat, _$concat4, _$concat5, _$concat7, _$concat9, _Object$assign;
  var componentCls = token.componentCls,
    collapseContentBg = token.collapseContentBg,
    padding = token.padding,
    collapseContentPaddingHorizontal = token.collapseContentPaddingHorizontal,
    collapseHeaderBg = token.collapseHeaderBg,
    collapseHeaderPadding = token.collapseHeaderPadding,
    collapseHeaderPaddingSM = token.collapseHeaderPaddingSM,
    collapseHeaderPaddingLG = token.collapseHeaderPaddingLG,
    collapsePanelBorderRadius = token.collapsePanelBorderRadius,
    lineWidth = token.lineWidth,
    lineType = token.lineType,
    colorBorder = token.colorBorder,
    colorText = token.colorText,
    colorTextHeading = token.colorTextHeading,
    colorTextDisabled = token.colorTextDisabled,
    fontSize = token.fontSize,
    fontSizeLG = token.fontSizeLG,
    lineHeight = token.lineHeight,
    marginSM = token.marginSM,
    paddingSM = token.paddingSM,
    paddingLG = token.paddingLG,
    paddingXS = token.paddingXS,
    motionDurationSlow = token.motionDurationSlow,
    fontSizeIcon = token.fontSizeIcon;
  var borderBase = "".concat(lineWidth, "px ").concat(lineType, " ").concat(colorBorder);
  return _defineProperty({}, componentCls, Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign = {
    backgroundColor: collapseHeaderBg,
    border: borderBase,
    borderBottom: 0,
    borderRadius: "".concat(collapsePanelBorderRadius, "px")
  }, _defineProperty(_Object$assign, "&-rtl", {
    direction: 'rtl'
  }), _defineProperty(_Object$assign, "& > ".concat(componentCls, "-item"), (_$concat4 = {
    borderBottom: borderBase
  }, _defineProperty(_$concat4, "&:last-child", _defineProperty({}, "\n            &,\n            & > ".concat(componentCls, "-header"), {
    borderRadius: "0 0 ".concat(collapsePanelBorderRadius, "px ").concat(collapsePanelBorderRadius, "px")
  })), _defineProperty(_$concat4, "> ".concat(componentCls, "-header"), (_$concat = {
    position: 'relative',
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'flex-start',
    padding: collapseHeaderPadding,
    paddingInlineStart: paddingSM,
    color: colorTextHeading,
    lineHeight: lineHeight,
    cursor: 'pointer',
    transition: "all ".concat(motionDurationSlow, ", visibility 0s")
  }, _defineProperty(_$concat, "> ".concat(componentCls, "-header-text"), {
    flex: 'auto'
  }), _defineProperty(_$concat, '&:focus', {
    outline: 'none'
  }), _defineProperty(_$concat, "".concat(componentCls, "-expand-icon"), {
    height: fontSize * lineHeight,
    display: 'flex',
    alignItems: 'center',
    paddingInlineEnd: marginSM,
    // Arrow offset
    marginInlineStart: padding - paddingSM
  }), _defineProperty(_$concat, "".concat(componentCls, "-arrow"), Object.assign(Object.assign({}, resetIcon()), {
    fontSize: fontSizeIcon,
    svg: {
      transition: "transform ".concat(motionDurationSlow)
    }
  })), _defineProperty(_$concat, "".concat(componentCls, "-header-text"), {
    marginInlineEnd: 'auto'
  }), _$concat)), _defineProperty(_$concat4, "".concat(componentCls, "-header-collapsible-only"), _defineProperty({
    cursor: 'default'
  }, "".concat(componentCls, "-header-text"), {
    flex: 'none',
    cursor: 'pointer'
  })), _defineProperty(_$concat4, "".concat(componentCls, "-icon-collapsible-only"), _defineProperty({
    cursor: 'default'
  }, "".concat(componentCls, "-expand-icon"), {
    cursor: 'pointer'
  })), _$concat4)), _defineProperty(_Object$assign, "".concat(componentCls, "-content"), (_$concat5 = {
    color: colorText,
    backgroundColor: collapseContentBg,
    borderTop: borderBase
  }, _defineProperty(_$concat5, "& > ".concat(componentCls, "-content-box"), {
    padding: "".concat(padding, "px ").concat(collapseContentPaddingHorizontal, "px")
  }), _defineProperty(_$concat5, "&-hidden", {
    display: 'none'
  }), _$concat5)), _defineProperty(_Object$assign, "&-small", _defineProperty({}, "> ".concat(componentCls, "-item"), (_$concat7 = {}, _defineProperty(_$concat7, "> ".concat(componentCls, "-header"), _defineProperty({
    padding: collapseHeaderPaddingSM,
    paddingInlineStart: paddingXS
  }, "> ".concat(componentCls, "-expand-icon"), {
    // Arrow offset
    marginInlineStart: paddingSM - paddingXS
  })), _defineProperty(_$concat7, "> ".concat(componentCls, "-content > ").concat(componentCls, "-content-box"), {
    padding: paddingSM
  }), _$concat7))), _defineProperty(_Object$assign, "&-large", _defineProperty({}, "> ".concat(componentCls, "-item"), (_$concat9 = {
    fontSize: fontSizeLG
  }, _defineProperty(_$concat9, "> ".concat(componentCls, "-header"), _defineProperty({
    padding: collapseHeaderPaddingLG,
    paddingInlineStart: padding
  }, "> ".concat(componentCls, "-expand-icon"), {
    height: fontSizeLG * lineHeight,
    // Arrow offset
    marginInlineStart: paddingLG - padding
  })), _defineProperty(_$concat9, "> ".concat(componentCls, "-content > ").concat(componentCls, "-content-box"), {
    padding: paddingLG
  }), _$concat9))), _defineProperty(_Object$assign, "".concat(componentCls, "-item:last-child"), _defineProperty({}, "> ".concat(componentCls, "-content"), {
    borderRadius: "0 0 ".concat(collapsePanelBorderRadius, "px ").concat(collapsePanelBorderRadius, "px")
  })), _defineProperty(_Object$assign, "& ".concat(componentCls, "-item-disabled > ").concat(componentCls, "-header"), _defineProperty({}, "\n          &,\n          & > .arrow\n        ", {
    color: colorTextDisabled,
    cursor: 'not-allowed'
  })), _defineProperty(_Object$assign, "&".concat(componentCls, "-icon-position-end"), _defineProperty({}, "& > ".concat(componentCls, "-item"), _defineProperty({}, "> ".concat(componentCls, "-header"), _defineProperty({}, "".concat(componentCls, "-expand-icon"), {
    order: 1,
    paddingInlineEnd: 0,
    paddingInlineStart: marginSM
  })))), _Object$assign)));
};
var genArrowStyle = function genArrowStyle(token) {
  var componentCls = token.componentCls;
  var fixedSelector = "> ".concat(componentCls, "-item > ").concat(componentCls, "-header ").concat(componentCls, "-arrow svg");
  return _defineProperty({}, "".concat(componentCls, "-rtl"), _defineProperty({}, fixedSelector, {
    transform: "rotate(180deg)"
  }));
};
var genBorderlessStyle = function genBorderlessStyle(token) {
  var _$concat15;
  var componentCls = token.componentCls,
    collapseHeaderBg = token.collapseHeaderBg,
    paddingXXS = token.paddingXXS,
    colorBorder = token.colorBorder;
  return _defineProperty({}, "".concat(componentCls, "-borderless"), (_$concat15 = {
    backgroundColor: collapseHeaderBg,
    border: 0
  }, _defineProperty(_$concat15, "> ".concat(componentCls, "-item"), {
    borderBottom: "1px solid ".concat(colorBorder)
  }), _defineProperty(_$concat15, "\n        > ".concat(componentCls, "-item:last-child,\n        > ").concat(componentCls, "-item:last-child ").concat(componentCls, "-header\n      "), {
    borderRadius: 0
  }), _defineProperty(_$concat15, "> ".concat(componentCls, "-item:last-child"), {
    borderBottom: 0
  }), _defineProperty(_$concat15, "> ".concat(componentCls, "-item > ").concat(componentCls, "-content"), {
    backgroundColor: 'transparent',
    borderTop: 0
  }), _defineProperty(_$concat15, "> ".concat(componentCls, "-item > ").concat(componentCls, "-content > ").concat(componentCls, "-content-box"), {
    paddingTop: paddingXXS
  }), _$concat15));
};
var genGhostStyle = function genGhostStyle(token) {
  var componentCls = token.componentCls,
    paddingSM = token.paddingSM;
  return _defineProperty({}, "".concat(componentCls, "-ghost"), _defineProperty({
    backgroundColor: 'transparent',
    border: 0
  }, "> ".concat(componentCls, "-item"), _defineProperty({
    borderBottom: 0
  }, "> ".concat(componentCls, "-content"), _defineProperty({
    backgroundColor: 'transparent',
    border: 0
  }, "> ".concat(componentCls, "-content-box"), {
    paddingBlock: paddingSM
  }))));
};
export default genComponentStyleHook('Collapse', function (token) {
  var collapseToken = mergeToken(token, {
    collapseContentBg: token.colorBgContainer,
    collapseHeaderBg: token.colorFillAlter,
    collapseHeaderPadding: "".concat(token.paddingSM, "px ").concat(token.padding, "px"),
    collapseHeaderPaddingSM: "".concat(token.paddingXS, "px ").concat(token.paddingSM, "px"),
    collapseHeaderPaddingLG: "".concat(token.padding, "px ").concat(token.paddingLG, "px"),
    collapsePanelBorderRadius: token.borderRadiusLG,
    collapseContentPaddingHorizontal: 16 // Fixed value
  });

  return [genBaseStyle(collapseToken), genBorderlessStyle(collapseToken), genGhostStyle(collapseToken), genArrowStyle(collapseToken), genCollapseMotion(collapseToken)];
});